export default "__VITE_ASSET__aa123024__"